import { Component, output, signal } from '@angular/core';
import { ButtonDirective } from '../../primitives/button/button.directive';

/** A brief dismissible message displayed above the application. */
@Component({
  selector: 'cui-toast',
  standalone: true,
  imports: [ButtonDirective],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.css',
  host: {
    '[class.cui-toast--error]': 'variant() === "error"',
    '[attr.role]': 'variant() === "error" ? "alert" : "status"',
  },
})
export class CuiToastComponent {
  /** Outputs. */
  readonly dismiss = output<void>();

  /** State. */
  readonly message = signal('');
  readonly variant = signal<'error' | 'info'>('info');
}
